import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/auth";
import { Button } from "@/components/ui/button";
import { isValidRelativePath } from "@/utils/urlValidation";

export function LoginButton() {
  const { loginWithRedirect, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  const handleLogin = () => {
    const returnToParam = searchParams.get("returnTo");

    let returnTo: string;
    if (returnToParam) {
      try {
        const decoded = decodeURIComponent(returnToParam);
        if (isValidRelativePath(decoded)) {
          returnTo = decoded;
        } else {
          returnTo = window.location.pathname + window.location.search;
        }
      } catch {
        returnTo = window.location.pathname + window.location.search;
      }
    } else {
      returnTo = window.location.pathname + window.location.search;
    }

    loginWithRedirect({ appState: { returnTo } });
  };

  return (
    <Button onClick={handleLogin} disabled={isLoading} size="lg">
      {isLoading ? "Loading..." : "Log In"}
    </Button>
  );
}
